import * as React from 'react';
import { useSelector } from 'react-redux';

import { PhoneButtonTablet } from '../../components/PhoneButton';
import { selectBuilderInfo } from '../../selectors/newbuilding';
import { usePhoneButton } from './hooks/usePhoneButton';

export const PhoneButtonTabletContainer: React.FC = () => {
  const builderInfo = useSelector(selectBuilderInfo);
  const { handlePhoneCall, handlePhoneShow, phone } = usePhoneButton();

  if (!phone) {
    return null;
  }

  return (
    <PhoneButtonTablet
      builderLogoUrl={builderInfo?.logoUrl}
      builderName={builderInfo?.name}
      phone={phone}
      onPhoneClick={handlePhoneCall}
      onPhoneShow={handlePhoneShow}
    />
  );
};
